import { TestResponseItemCombinedProps } from './types';

const usePresenter = (props: TestResponseItemCombinedProps): TestResponseItemCombinedProps => {
  return props;
};

export default usePresenter;
